module.exports = __webpack_public_path__ + "static/media/WhitneyCond-Book.ed84496f.otf";